// extracted by mini-css-extract-plugin
export var colorSquare = "_th-0";
export var danger = "_th-5";
export var lightPink = "_th-8";
export var neutralBlue = "_th-7";
export var neutralYellow = "_th-6";
export var normal = "_th-1";
export var primary = "_th-2";
export var primaryLight = "_th-3";
export var solidBlack = "_th-g";
export var solidGreen = "_th-b";
export var solidLightBlue = "_th-d";
export var solidNavy = "_th-c";
export var solidOrange = "_th-f";
export var solidPink = "_th-e";
export var solidRed = "_th-9";
export var solidYellow = "_th-a";
export var success = "_th-4";